export function normalizeUsername(username) {
  return username ? username.toLowerCase() : username;
}
